import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import {
  ClearOrderPayment,
  FetchPaymentStatus
} from './+state/payment.actions';
import { LocalStorageService } from 'src/app/local-storage.service';
import { HelperService } from '../helper.service';
import { ReferenceType } from '../store/types/IntegrationPayment';
import { PaymentRedirectGuardBase } from './payment-redirect.guard.base';
import { getOrderPaymentStore } from './+state/payment.selectors';
import { takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentRedirectGuard extends PaymentRedirectGuardBase {

  constructor(protected store: Store<any>,
    protected router: Router,
    protected helperService: HelperService,
    protected zone: NgZone,
    protected storageService: LocalStorageService) {
    super(store, router, helperService, zone, storageService);
  }

  protected selectAndDispatchPaymentStoreState(routeParams: Params, referenceType: ReferenceType) {
    this.store.select(getOrderPaymentStore)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(orderPayment => {
      this.processNavigation(orderPayment?.orderPaymentState?.status, routeParams, referenceType, orderPayment.orderPaymentState);
    });
  }

  protected getFetchPaymentAction(storeId: number, paymentId: string, orderId: string, referenceType: ReferenceType): Action {
    return new FetchPaymentStatus(storeId, orderId, referenceType == ReferenceType.STANDALONE_PAYMENT);
  }

  protected getReferenceType(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ReferenceType {
    let referenceType = ReferenceType.ORDER;
    if (state.url.includes('/sp/')) referenceType = ReferenceType.STANDALONE_PAYMENT;
    return referenceType;
  }

  protected getCompletePaymentSuccessStatus() {
    return "COMPLETE_ORDER_PAYMENT_SUCCESS";
  }
  protected onCompletePaymentSuccess(referenceType: ReferenceType, paymentstate: any) {
    this.storageService.setSavedState(true, 'standalone-payment-completed');
  }
  protected getCompletePaymentFailureStatus() {
    return "COMPLETE_ORDER_PAYMENT_FAILURE";
  }
  protected onCompletePaymentFailure(referenceType: ReferenceType, paymentstate: any) {
    this.store.dispatch(new ClearOrderPayment());
    this.storageService.setSavedState(true, 'standalone-payment-completed');
  }
}
